import {AfterViewInit, Component, ElementRef, Input, NgZone, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FilterItem, Ordine, OrdineEsolver} from '../../_models/_Index';
import {LocalService} from '../../_services/local.service';
import {OrganizzazioniService} from '../../_services/organizzazioni.service';
import {Subscription} from 'rxjs';
import {skip} from 'rxjs/operators';
import {SaveMessage} from '../../_helpers/save-message';
import {TipoFormControl} from '../../_helpers/TipoFormControl';
import {OrdineEsolverGroup} from '../../_models/OrdineEsolverGroup';
import {OrdiniShowColumns} from '../../_models/OrdiniShowColumns';
import {AccountOrganizzazione} from "../../_models/AccountOrganizzazione";
import {AutoLoadTriggerObserver} from '../../_helpers/auto-load-trigger-observer';

@Component({
  selector: 'app-ordini-esolver',
  templateUrl: './ordini-esolver.component.html',
  styleUrls: ['./ordini-esolver.component.scss'],
  standalone: false
})
export class OrdiniEsolverComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() isPersonal: boolean;
  @Input() onlyContoLavoro = false;
  viewGroup: boolean;
  ordiniEsolverApp: OrdineEsolver[] = [];
  ordiniEsolverGroup: OrdineEsolverGroup[] = [];
  totalCount = 0;
  subscription: Subscription;
  sortDirection = false;
  sortKey = 'dataTermine';
  loading = false;
  search = '';
  loadMore = false;
  page = 0;
  count = 20;
  showColumns: OrdiniShowColumns = {};
  filters: FilterItem[] = [
    {fieldName: 'NumRegistrazione', operazione: 1, value1: '', value2: '', tipoFormControl: TipoFormControl.inputText, showColumn: this.localService.showColumns.value.numRegistrazione},
    {fieldName: 'Commessa', operazione: 5, value1: '', value2: '', tipoFormControl: TipoFormControl.inputText, showColumn: this.localService.showColumns.value.commessa},
    {fieldName: 'RifOrdine', operazione: 1, value1: '', value2: '', tipoFormControl: TipoFormControl.inputText, showColumn: this.localService.showColumns.value.rifOrdine},
    {fieldName: 'CodiceOrdine', operazione: 1, value1: '', value2: '', tipoFormControl: TipoFormControl.selectOrdine, showColumn: this.localService.showColumns.value.idDocumento},
    {fieldName: 'RifOdP', operazione: 5, value1: '', value2: '', tipoFormControl: TipoFormControl.inputText, showColumn: this.localService.showColumns.value.rifOdP},
    {fieldName: 'NumFase', operazione: 1, value1: '', value2: '', tipoFormControl: TipoFormControl.inputNumber, showColumn: this.localService.showColumns.value.numFase},
    {
      fieldName: 'DataRegistrazione', operazione: 8,
      value1: new Date(2000, 0, 1, 0, 0, 0).toISOString(),
      value2: new Date(2099, 11, 31, 1, 0, 0).toISOString(), tipoFormControl: TipoFormControl.datetime, showColumn: this.localService.showColumns.value.dataRegistrazione
    },
    {
      fieldName: 'DataTermine', operazione: 8,
      value1: new Date(2000, 0, 1, 0, 0, 0).toISOString(),
      value2: new Date(2099, 11, 31, 1, 0, 0).toISOString(), tipoFormControl: TipoFormControl.datetime, showColumn: this.localService.showColumns.value.dataTermine
    },
    {fieldName: 'Risorsa', operazione: 5, value1: '', value2: '', tipoFormControl: TipoFormControl.inputText, showColumn: this.localService.showColumns.value.risorsa},
    {fieldName: 'Lavorazione', operazione: 5, value1: '', value2: '', tipoFormControl: TipoFormControl.inputText, showColumn: this.localService.showColumns.value.lavorazione},
    {fieldName: 'CodiceArticolo', operazione: 5, value1: '', value2: '', tipoFormControl: TipoFormControl.inputText, showColumn: this.localService.showColumns.value.codiceArticolo},
    {fieldName: 'VarianteArt', operazione: 5, value1: '', value2: '', tipoFormControl: TipoFormControl.inputText, showColumn: this.localService.showColumns.value.varianteArt},
    {fieldName: 'CodCliente', operazione: 1, value1: '', value2: '', tipoFormControl: TipoFormControl.inputNumber, showColumn: this.localService.showColumns.value.codCliente},
    {fieldName: 'IdOrdVen', operazione: 1, value1: '', value2: '', tipoFormControl: TipoFormControl.inputNumber, showColumn: this.localService.showColumns.value.idOrdVen},
    {fieldName: 'CodTerzista', operazione: 1, value1: '', value2: '', tipoFormControl: TipoFormControl.inputNumber, showColumn: this.localService.showColumns.value.codTerzista},
    {fieldName: 'UdM', operazione: 5, value1: '', value2: '', tipoFormControl: TipoFormControl.inputText, showColumn: this.localService.showColumns.value.udM},
    {fieldName: 'QtaOrdine', operazione: 3, value1: '-99999', value2: '', tipoFormControl: TipoFormControl.inputNumber, showColumn: this.localService.showColumns.value.quantita},
    {fieldName: 'Quantita', operazione: 3, value1: '-99999', value2: '', tipoFormControl: TipoFormControl.inputNumber, showColumn: this.localService.showColumns.value.quantitaToDo},
    {fieldName: 'Stato', operazione: 1, value1: '1', value2: '', tipoFormControl: TipoFormControl.select, options: [], showColumn: this.localService.showColumns.value.stato}
  ];
  // Click multipli su "aggiorna" (o ricerca + refresh quasi simultanei) possono lanciare più
  // richieste in sovrapposizione: senza guard la risposta che arriva per ultima vince anche se
  // non è la più recente, facendo sfarfallare totalCount tra un valore vecchio e uno nuovo.
  private requestToken = 0;
  private autoLoadTriggerElement?: ElementRef<HTMLElement>;
  private readonly autoLoadTriggerObserver = new AutoLoadTriggerObserver(this.ngZone, () => this.autoLoadMore());

  constructor(
    private organizzazioniService: OrganizzazioniService,
    private saveMessage: SaveMessage,
    private ngZone: NgZone,
    private localService: LocalService) { }

  @ViewChild('autoLoadTrigger')
  set autoLoadTrigger(element: ElementRef<HTMLElement> | undefined) {
    this.autoLoadTriggerElement = element;
    this.observeAutoLoadTrigger();
  }

  async ngOnInit() {
    if (this.onlyContoLavoro) {
      this.filters
        .push({fieldName: 'FaseContoLavoro', operazione: 1, value1: '1', value2: '', tipoFormControl: TipoFormControl.inputText, showColumn: false});
    }
    // Inizializzazione sincrona prima delle subscription per evitare il primo caricamento con valori non corretti
    this.viewGroup = this.organizzazioniService.viewGroup;
    this.showColumns = this.localService.showColumns.value;

    this.subscription = this.localService.searchText.subscribe((_value: string) => {
      this.search = _value;
      void this.refresh(false);
    });
    this.subscription.add(this.localService.lastOrdineCreated.subscribe((_newOrdine: Ordine) => {
      if (_newOrdine != null) {
        this.excludeOrdine(_newOrdine);
      }
    }));
    // skip(1): viewGroup già inizializzato sopra, reagisce solo ai cambi successivi
    this.subscription.add(this.organizzazioniService.currentAccountSettingsSubject
      .pipe(skip(1))
      .subscribe((_accountOrg: AccountOrganizzazione) => {
        if (_accountOrg && this.viewGroup !== _accountOrg.activeViewGroup) {
          this.viewGroup = _accountOrg.activeViewGroup;
          void this.refresh(false);
        }
      }));
    // skip(1): showColumns già inizializzato sopra, reagisce solo ai cambi successivi
    this.subscription.add(this.localService.showColumns
      .pipe(skip(1))
      .subscribe((_showColumns: OrdiniShowColumns) => this.showColumns = _showColumns));
  }

  ngAfterViewInit(): void {
    this.observeAutoLoadTrigger();
  }

  autoLoadMore(): void {
    if (this.loading || !this.loadMore) {
      return;
    }

    void this.refresh(true);
  }

  refresh = (add: boolean) => {
    this.loadMore = true;
    if (!add) {
      this.page = 0;
      this.ordiniEsolverApp = [];
      this.ordiniEsolverGroup = [];
    } else {
      this.page += 1;
    }
    this.loading = true;
    if (!this.viewGroup) {
      return this.getOrdiniFromEsolver(add);
    } else {
      return this.getOrdiniGroupFromEsolver(add);
    }
  };

  async getOrdiniFromEsolver(add: boolean) {
    const token = ++this.requestToken;
    try {
      const _result = await this.localService.getOrdiniEsolver(this.organizzazioniService.organizzazioneId, this.organizzazioniService.gruppoCodice,
        this.organizzazioniService.organizzazioneCodice, this.search, this.page, this.count,
        this.sortKey, this.sortDirection, true, this.isPersonal,
        this.organizzazioniService.activeAvpExt, this.filters, false);

      if (token !== this.requestToken) {
        return;
      }

      this.totalCount = _result.totalCount;
      if (_result.totalCount === 0) {
        this.ordiniEsolverApp = [];
        this.loadMore = false;
        return;
      }
      if (!add) {
        this.ordiniEsolverApp = _result.result;
      } else {
        _result.result.forEach((ord: OrdineEsolver) => this.ordiniEsolverApp.push(ord));
      }
      this.loadMore = _result.totalCount > this.ordiniEsolverApp.length;
    } catch {
      if (token !== this.requestToken) {
        return;
      }
      this.saveMessage.messageError("Problemi con il caricamento degli ordini pianificati in ESOLVER.");
    } finally {
      if (token === this.requestToken) {
        this.loading = false;
      }
    }
  }

  async getOrdiniGroupFromEsolver(add: boolean) {
    const token = ++this.requestToken;
    const groupColumns = this.organizzazioniService.groupColumnsArray;
    try {
      const _result = await this.localService.getOrdiniGroupEsolver(this.organizzazioniService.organizzazioneId, this.organizzazioniService.gruppoCodice,
        this.organizzazioniService.organizzazioneCodice, this.search, this.page, this.count,
        this.sortKey, this.sortDirection, true, this.isPersonal,
        this.organizzazioniService.activeAvpExt, this.filters, groupColumns);

      if (token !== this.requestToken) {
        return;
      }

      this.totalCount = _result.totalCount;
      if (_result.totalCount === 0) {
        this.ordiniEsolverGroup = [];
        this.loadMore = false;
        return;
      }
      if (!add) {
        this.ordiniEsolverGroup = _result.result;
      } else {
        _result.result.forEach((ord: OrdineEsolverGroup) => this.ordiniEsolverGroup.push(ord));
      }
      this.loadMore = _result.totalCount > this.ordiniEsolverGroup.length;
    } catch {
      if (token !== this.requestToken) {
        return;
      }
      this.saveMessage.messageError("Problemi con le API ESOLVER: controllare l'URL nella configurazione.");
    } finally {
      if (token === this.requestToken) {
        this.loading = false;
      }
    }
  }

  sort(key: string) {
    if (this.sortKey === key) {
      this.sortDirection = !this.sortDirection;
    }
    this.sortKey = key;
    void this.refresh(false);
  }

  excludeOrdine = (ordine: Ordine) => {
    this.ordiniEsolverApp = this.ordiniEsolverApp.filter((_ordine: OrdineEsolver) =>
      !(ordine.idDocumento === _ordine.idDocumento &&
        ordine.idRiga === _ordine.idRiga &&
        ordine.idRigaLavorazione === _ordine.idRigaLavorazione));
  };

  ngOnDestroy(): void {
    this.autoLoadTriggerObserver.disconnect();
    this.subscription.unsubscribe();
  }

  private observeAutoLoadTrigger(): void {
    this.autoLoadTriggerObserver.observe(this.autoLoadTriggerElement);
  }
}
